const { default: axiosInstance } = require("utils/axios");

const getListCustomerCar = async (filter) => {
  try {
    const response = await axiosInstance.get("/car-customer/get-customer", {
      params: {
        ...filter,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching get list customer car:", error);
    throw error;
  }
};

const getCustomerCarById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/car-customer/get-customer/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching get customer car by ID:", error);
    throw error;
  }
};

const CustomerCarService = {
  getListCustomerCar,
  getCustomerCarById,
};
export default CustomerCarService;
